import React from "react";
import { Snackbar, Alert } from "@mui/material";

type WarningProps = {
  text: string;
  severity: "error" | "success" | "warning" | "info";
  closeCallback: () => void;
};

const Warning: React.FC<WarningProps> = ({ text, severity, closeCallback }) => {
  return (
    <Snackbar
      open={true}
      autoHideDuration={3000}
      onClose={() => closeCallback()}
    >
      <Alert
        severity={severity}
        sx={{
          top: "6px",
          right: "16px",
          minWidth: "250px",
          position: "fixed",
        }}
      >
        {text}
      </Alert>
    </Snackbar>
  );
};
export default Warning;
